import React, { Fragment } from 'react';
import { withStyles } from "tss-react/mui";
import browserDetect from 'browser-detect';
import styles from './styles';

export const browser = browserDetect();

const isBrowserSupported = () => {
    if (browser.name === 'ie') {
        return false;
    }

    return true;
};

function BrowserSupport(props) {
    // eslint-disable-next-line react/prop-types
    const { classes } = props;
    if (!isBrowserSupported()) {
        return (
            <div className={classes.root}>
                <div className={classes.header}>
                    <img src="/logo.png" alt="logo" className={classes.logo} />
                </div>

                <div className={classes.inner}>
                    <span className={classes.text}>Internet Explorer is no longer supported.</span><br />
                    <span className={classes.text}>Download the latest version of a supported browser if required:</span><br />
                    <ul>
                        <li><a rel="noopener noreferrer" href="https://www.mozilla.org/en-US/firefox/new/" target="_blank">Firefox</a></li>
                        <li><a rel="noopener noreferrer" href="https://www.google.com/intl/en_au/chrome/" target="_blank">Google Chrome</a></li>
                        <li><a rel="noopener noreferrer" href="https://www.microsoft.com/en-us/edge?r=1" target="_blank">Microsoft Edge</a></li>
                    </ul>
                </div>

            </div>

        );
    }

    return (
        <Fragment>
            {props.children}
        </Fragment>);
}

export default withStyles(BrowserSupport, styles);